import styled from 'styled-components';
import { InputGroup } from 'react-bootstrap';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';

export const Dropdown = styled(InputGroup)`
  height: 25px;

  select.form-control {
    height: 25px;
    font-size: ${({ theme: { fontSize } }) => fontSize.normal};
    background-image: url(${STATIC_IMAGE_URLS.icons.arrowIcon});
    background-repeat: no-repeat;
    background-position: right 0.4rem center;
    background-size: 11px 11px;
    padding-right: 22px;
    line-height: 1;
    border: 1px solid ${COLORS.GREY_32};
  }

  .is-invalid {
    background-image: none;
  }
`;
